import type { KeyboardEvent } from 'react';
import { KeyboardKey } from '../../constants/keyboardKeys';

export function handleButtonKeyDown(event: KeyboardEvent<HTMLElement>) {
  if (event.key === KeyboardKey.Enter || event.key === KeyboardKey.Space) {
    event.preventDefault();
    event.currentTarget.click();
  }
}
